module.exports = __webpack_public_path__ + "img/600.bc790159.svg";